import { NodeList } from "../../Utils/Collections/NodeList";
import { ActiveBonus } from "./ActiveBonus";
import { Bonus, eBonusUID, BONUSES } from "./Bonus";
import { Pool } from "../../Utils/Collections/Pool";
import { Node } from "../../Utils/Collections/Node";
import { Section as WorldSection, eType as eWorldSectionType } from "../Game World/Sections/Section";
import { TIMER, TIME } from "../Gameplay";
import { RND } from "../../Utils/RND";
import { GameWorld } from "../Game World/GameWorld";
import { Timer } from "../../Utils/Time/Timer";
import { rnd } from "../../Game";



export class BonusManager {
    /**
     * (RO) Staticky pristup
     */
    static get instance(): BonusManager { return BonusManager._instance; }
    private static _instance: BonusManager;

    /**
     * (RO) Casovac aktivnich bonusu
     */
    static ACT_BONUS_TIMER: Timer;

    /**
     * Minimalni interval vhazovani bonusu do herniho sveta
     */
    private static readonly THROW_MIN_INTERVAL = 7500;

    /**
     * Maximalni interval vhazovani bonusu do herniho sveta
     */
    private static readonly THROW_MAX_INTERVAL = 15000;

    /**
     * Cas, kdy ma dojit ke vhozeni dalsiho bonusu do herniho sveta
     */
    private _nextBnsTime: number;

    /**
     * Sekce herniho sveta, do kterych je mozne vhazovat bonusy
     */
    private _bnsSections: WorldSection[];

    /**
     * Priorita vyberu dane sekce
     */
    private _bnsSectionsPriority: number[];

    /**
     * Index sekce, do ktere bude vhozen dalsi bonus
     */
    private _nextBnsSecId: number;

    /**
     * Priorita vyberu bonusu s danym UID jako dalsiho bonusu
     */
    private _bnsUIDPriority: number[];

    /**
     * Pocet bonusu, ktere byli vhozeny do herniho sveta, ale hrac je nesebral (od posledniho sebraneho bonusu)
     */
    private _missedBnsCnt: number;

    /**
     * Udalost vyvolana pri aktivaci bonusu. Ke jmenu udalosti je potreba pridat UID bonusu.
     * Parametry:
     * - bonus: ActiveBonus
     * - react: boolean (true, pokud doslo k aktivaci jiz aktivniho bonusu)
     */
    static readonly EVENT_BONUS_ACTIVATE = "bns:activate_";

    /**
     * Udalost vyvolana po deaktivaci bonusu. Ke jmenu udalosti je potreba pridat UID bonusu.
     * Parametry: (bonusUID: eBonusUID)
     */
    static readonly EVENT_BONUS_DEACTIVATE = "bns:deactivate_";

    /**
    * (RO) Spravce udalosti
    */
    get events(): pc.EventHandler { return this._events; }
    private _events: pc.EventHandler;

    /**
     * Seznam aktivnich bonusu
     */
    private _actBonuses: NodeList<ActiveBonus>;

    /**
     * Pool s volnymi aktivnimi bonusy
     */
    private _actBonusesPool: Pool<ActiveBonus>;

    /**
     * Maska UID aktivnich bonusu
     */
    private _actBonusMask: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        BonusManager._instance = this;
        BonusManager.ACT_BONUS_TIMER = TIME.createTimer();

        // Udalosti
        this._events = new pc.EventHandler();

        // Aktivni bonusy
        this._actBonuses = new NodeList<ActiveBonus>();
        this._actBonusesPool = new Pool<ActiveBonus>(ActiveBonus, 1, true);

        // Sekce pro zobrazeni bonusu
        this._bnsSections = [];
        this._bnsSectionsPriority = [];
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Casovac aktivnich bonusu
        BonusManager.ACT_BONUS_TIMER.start();

        // Resetovat aktivni bonusy
        this._actBonuses.forEach((bonus: ActiveBonus) => { this._actBonusesPool.returnItem(bonus); })
        this._actBonuses.clear();
        this._actBonusMask = 0;

        // Vhazovani bonusu do herniho sveta
        this._missedBnsCnt = 0;

        this._bnsSections.length = 0;
        this._bnsSectionsPriority.length = 0;

        GameWorld.instance.sections.forEach((section: WorldSection) => {
            let type = section.type;

            if (type == eWorldSectionType.road1 || type == eWorldSectionType.road2 || type == eWorldSectionType.carousel) {
                this._bnsSections.push(section);
                this._bnsSectionsPriority.push(1);
            }
        });

        // Resetovat prioritu UID bonusu
        let i = BONUSES.length;

        if (!this._bnsUIDPriority) {
            this._bnsUIDPriority = [];

            while (i-- != 0)
                this._bnsUIDPriority.push(1);
        }
        else {
            while (i-- != 0)
                this._bnsUIDPriority[i] = 1;
        }

        this.prepareNextBonus();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        // Zkontrolovat platnost aktivnich bonusu
        this._actBonuses.forEach((bns: ActiveBonus, node: Node<ActiveBonus>) => {
            if (bns.remTime <= 0) {
                let bnsUID = bns.bonus.uid;

                this._actBonusMask &= ~(1 << bnsUID);
                this._actBonusesPool.returnItem(this._actBonuses.removeByNode(node));

                this._events.fire(BonusManager.EVENT_BONUS_DEACTIVATE + bnsUID, bnsUID);
            }
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activateBonus(bonus: Bonus): void {
        // Resetovat pocet nesebranych bonusu a pripravit vypusteni dalsiho bonusu
        this._missedBnsCnt = 0;
        this.prepareNextBonus(true);

        // Nastavit aktivni bonus        
        let actBns: ActiveBonus;
        let react = false;

        if ((this._actBonusMask & (1 << bonus.uid)) == 0) {
            actBns = this._actBonusesPool.getItem();

            this._actBonuses.add(actBns.init(bonus));
            this._actBonusMask |= (1 << bonus.uid);
        }
        else {
            this._actBonuses.every((b: ActiveBonus): boolean => {
                if (b.bonus.uid == bonus.uid) {
                    actBns = b;
                    actBns.resetActTime();
                    return false;
                }

                return true;
            });

            react = true;
        }

        // Vyvolat udalost
        this._events.fire(BonusManager.EVENT_BONUS_ACTIVATE + bonus.uid, actBns, react);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    isBonusActive(uid: eBonusUID): boolean {
        return (this._actBonusMask & (1 << uid)) != 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getBonusToThrow(section: WorldSection): Bonus {
        if (TIMER.time < this._nextBnsTime || section != this._bnsSections[this._nextBnsSecId])
            return undefined;

        // Vybrat typ bonusu
        let bns = BONUSES[rnd.choiceWithPriority(this._bnsUIDPriority)];

        // Pripravit vypusteni dalsiho bonusu
        this.prepareNextBonus();

        return bns;
    }

    //-------------------------------------------------------------------------
    /**
     * Navysit pocet bonusu, ktere hrac nesebrat od sebrani posledniho bonusu
     */
    //-------------------------------------------------------------------------
    incMissedBonuses(): void { this._missedBnsCnt++; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private prepareNextBonus(justTime: boolean = false): void {
        // Cas vhozeni dalsiho bonusu
        this._nextBnsTime = TIMER.time + rnd.randomIntIn(BonusManager.THROW_MIN_INTERVAL, BonusManager.THROW_MAX_INTERVAL - (BonusManager.THROW_MAX_INTERVAL - BonusManager.THROW_MIN_INTERVAL) * Math.min(1, this._missedBnsCnt / 5));

        if (!justTime) {
            // Sekce, ve ktere se pristi bonusu objevi
            this._nextBnsSecId = rnd.choiceWithPriority(this._bnsSectionsPriority);
        }
    }
}